import { Button, useTheme } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { handleHeight, handleFontSize } from "./utils";

export const ButtonPrimary = ({
  onClick,
  disabled,
  startIcon,
  endIcon,
  children,
  id,
  size = "sm",
}: IButtons) => {
  const theme = useTheme();
  return (
    <Button
      id={id}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: !disabled
          ? theme.palette.backgroundPrimaryCTA
          : theme.palette.backgroundDisabled,
        color: theme.palette.text.primaryCta,
        height: handleHeight(size),
        lineHeight: "1.5rem",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: handleFontSize(size),
        fontStyle: "normal",
        padding: "0.78rem 1rem",
        "&:hover": { backgroundColor: theme.palette.backgroundPrimaryCTAHover },
        //TODO da finire i vari stati (active, focus)
      }}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {children}
    </Button>
  );
};
